/* Test-theme only. The checkout remains available on every error path. */
(() => {
  if (window.__tlTopup) return;
  window.__tlTopup = true;
  let busy = false;
  let cartChanged = false;
  const money = cents => new Intl.NumberFormat('es-CO', {style:'currency', currency:'COP', maximumFractionDigits:0}).format(cents / 100);
  const base = window.Shopify?.routes?.root || '/';
  const strong = text => { const node=document.createElement('strong'); node.textContent=text; return node; };
  const remainingMessage = (node, missing, reward) => {
    node.replaceChildren('Te faltan ',strong(money(missing)),' para obtener ',strong(reward),'.');
  };
  const checkout = () => { if(window.TLKitcito) window.TLKitcito.checkout().catch(error=>alert(error.message)); else location.href = base + 'checkout'; };
  document.addEventListener('click', async event => {
    const button = event.target.closest('.cart--checkout-button');
    if (!button) return;
    const cartRoot = button.closest('cart-element');
    const progress = cartRoot?.querySelector('[data-tl-qualifying]');
    if (!progress) return;
    const gap = Number(progress.dataset.tlNext) - Number(progress.dataset.tlQualifying);
    if (!(gap > 0 && gap <= 2500000)) return;
    const source = cartRoot.querySelector('[data-cart-recs]');
    if (!source?.querySelector('.tl-cart-rec')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (busy || document.querySelector('.tl-topup[open]')) return;
    document.querySelectorAll('.tl-topup').forEach(el=>el.remove());
    cartChanged = false;
    const dialog = document.createElement('dialog');
    dialog.className = 'tl-topup';
    dialog.setAttribute('aria-label', 'Completa tu compra y aprovecha el beneficio');
    const title = document.createElement('h2'); title.textContent = '¡Estás muy cerca!';
    const target = Number(progress.dataset.tlNext), reward = progress.dataset.tlReward;
    const message = document.createElement('p'); remainingMessage(message,gap,reward);
    const list = document.createElement('div');
    const cards = [...source.querySelectorAll('.tl-cart-rec')].slice(0,3);
    cards.forEach(original => {
      const card = original.cloneNode(true); card.hidden = false;
      card.querySelectorAll('[id]').forEach(el=>el.removeAttribute('id'));
      const add = card.querySelector('[data-rec-add]');
      add.removeAttribute('data-rec-add'); add.setAttribute('data-topup-add','');
      add.textContent = 'Añadir'; list.append(card);
    });
    const status = document.createElement('p'); status.setAttribute('role','status');
    const skip = document.createElement('button'); skip.type='button'; skip.className='tl-topup-skip'; skip.textContent='No, gracias. Ir a pagar';
    skip.addEventListener('click',checkout);
    const close = document.createElement('button');
    close.type='button'; close.className='tl-topup-close'; close.textContent='×';
    close.setAttribute('aria-label','Cerrar y seguir comprando');
    const dismiss = () => {
      dialog.close(); dialog.remove();
      const returnTo = button.isConnected ? button : document.querySelector('.cart--checkout-button');
      returnTo?.focus();
    };
    close.addEventListener('click',dismiss);
    dialog.append(title,message,list,status,skip,close); document.body.append(dialog);
    dialog.addEventListener('cancel',event=>{event.preventDefault();dismiss();});
    dialog.addEventListener('click',async e=>{
      const add=e.target.closest('[data-topup-add]'); if(!add || busy)return;
      const variant=add.closest('.tl-cart-rec').querySelector('[data-rec-variant]').value;
      busy=true; skip.disabled=true; dialog.querySelectorAll('[data-topup-add]').forEach(b=>b.disabled=true);
      status.textContent='Añadiendo…';
      try {
        const response=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(variant),quantity:1}]})});
        if(!response.ok)throw new Error('add failed');
        cartChanged=true;
        if(window.TLKitcito) await window.TLKitcito.ensure();
        const Cart=customElements.get('cart-element');
        const sections=Cart?.sections || ['cart-drawer','cart-desktop','cart-mobile'];
        const updated=await fetch(base+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:{},sections,sections_url:location.pathname})}).then(r=>{if(!r.ok)throw new Error('read failed');return r.json();});
        if(Cart && updated.sections) {
          Cart.fillBasket(updated.items); Cart.updateTotals(updated.item_count); Cart.updateAllHtml(updated.sections);
        }
        const amount=updated.items.filter(i=>!i.gift_card && i.handle!=='kit-obsequio-amor-y-amistad').reduce((sum,i)=>sum+i.final_line_price,0);
        const missing=target-amount;
        if(missing>0) {
          remainingMessage(message,missing,reward);
          status.replaceChildren('Añadido. Aún faltan ',strong(money(missing)),' para esta meta.');
        } else {
          message.replaceChildren('¡Alcanzaste la meta de ',strong(reward),'!');
          status.textContent='¡Añadido! Tu carrito ya está actualizado.';
        }
        skip.textContent='Continuar a pagar';
      } catch { status.textContent='No pudimos confirmar el cambio. Revisa tu carrito antes de volver a añadir.'; }
      finally {busy=false;skip.disabled=false;dialog.querySelectorAll('[data-topup-add]').forEach(b=>b.disabled=false);}
    });
    dialog.showModal(); skip.focus();
  }, true);
})();
